import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/mp-material-constraints", { params });
};

const getAllForCSV = params => {
  return restApiMP.get("/api/mp-material-constraints/csv", { params });
};

const update = data => {
  return restApiMP.post("/api/mp-material-constraints", data);
}

const materialConstraintsService = {
  getAll,
  getAllForCSV,
  update
};

export default materialConstraintsService;